import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FaqsComponent } from '../../../../widgets/faqs/faqs.component';
import { FaqItem } from '../../../../core/interface/faq.modal';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-itam',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [CommonModule, RouterLink, FeatureHero, FaqsComponent, FeatureRow],
})
export class ITAM {
  variant!: 'saas' | 'enterprise';

  whatIsParagraphs = [
    "IT Asset Management (ITAM) is a critical enabler for IT directors, heads, and managers looking to future-proof digital transformation initiatives. It encompasses the process of ensuring that IT hardware and IT assets are effectively accounted for, deployed, maintained, upgraded, and disposed of. Also, the asset records are maintained in the ITAM database.",
    "An effective IT asset management solution must equip teams to receive, tag, and maintain IT assets in a centralized inventory. That way, it becomes easy to track the end-to-end lifecycle."
  ];

  solutionParagraphs = [
    "Infraon’s IT asset management solutions are equipped to manage end-to-end IT asset lifecycles - from requisitions and purchasing to retirement or disposal. Your users can track IT asset availability, health, and performance with an intuitive dashboard for spreadsheet-free visualizations.",
    "Infraon also offers an agent-based and agentless IT asset management tool that can be customized based on your unique business needs. It comes with access to automated fault and incident management workflows.",
    "<strong>Do more with your ITAM solution than before.</strong>"
  ];

  otherFeaturesItems = [
    'Prebuilt Workflows',
    'Customizable Reporting',
    'User and Role Management',
    'Audit Trails',
    'Mobile Accessibility'
  ];

  singleSolutionParagraph = ["Continuously optimize the purchase, deployment, maintenance, and disposal of IT assets and their components in real-time without depending on multiple software."];
  optimizedResourcingParagraph = ["Effortlessly lower the overall costs of hardware asset management and software asset management without hiring expensive and certified resources."];
  noShadowExpensesParagraph = ["Accurately monitor the performance of IT asset management software vendors to prevent any contractual oversights or shadow expenses."];
  strengthenedSecurityParagraph = ["Seamlessly track and mitigate any security or compliance risks with actionable IT asset insights based on intelligent alerts and notifications."];

  bestPracticesParagraph = ["Infraon's IT asset management solution is rooted in industry best practices such as:"];
  bestPracticesItems = [
    'Advanced data analytics to gain insights into IT asset performance, usage, etc.',
    'Simplified identification, tracking, and reporting of IT assets',
    'Integrated approach to tracking IT asset costs, depreciation, and ROI',
    'Risk assessment to detect vulnerabilities and threats to the IT asset ecosystem',
    'Tagging and tracking technologies like RFID to streamline inventory management',
    'Change management procedures to manage modifications to IT assets'
  ];

  benefitsParagraph = ["By deploying Infraon's IT asset management solution, you can enjoy benefits like:"];
  benefitsItems = [
    'Easier to incorporate green IT practices in asset management',
    'Seamless collaboration between IT, finance, procurement, and other departments',
    'Cost efficiency by accurately tracking and managing IT assets',
    'Streamline IT operations through automated processes and centralized asset management',
    'Reduced risk of legal penalties and enhanced data governance'
  ];

  faqs: FaqItem[] = [
    {
      question: 'What is IT Asset Management?',
      answer: {
        paragraphs: ['<a href="/it-asset-management/what-is-itam">IT Asset Management (ITAM)</a> is a critical enabler for IT leaders to deliver digital transformation and cost optimization. It ensures that an organization’s assets are accounted for, deployed, maintained, upgraded, and disposed of when the time comes. The IT Asset management team receives hardware assets, tags them first, and keeps them in their inventory. It is tracked during the asset’s entire lifecycle, and the records are maintained in the IATM database.']
      }
    },
    {
      question: 'Why does your business need an Asset Management Solution?',
      answer: {
        paragraphs: ['Any business needs a robust Asset Management solution to ensure that all the purchased assets are tracked and accounted for seamlessly. When an employee raises a request for an asset, it is issued to them. When the employee separates from the organization and returns all the assets issued, the database is maintained with proper information. For BPO operations, the assets are assigned to the business unit, and they are made liable for their upkeep.']
      }
    },
    {
      question: 'What are the benefits of using IT Asset Management?',
      answer: {
        paragraphs: ["A powerful IT asset management solution has numerous advantages. Tracking of assets to ensure that there is no loss of equipment. It also helps centralize and manage the purchase, deployment, maintenance, and disposal of IT software components to mitigate the security risks and reduce time/effort/costs. The IATM engineer can monitor the performance of their IT asset management software vendors with real-time data."]
      }
    },
    {
      question: 'What are the various types of IT Asset Management solutions?',
      answer: {
        paragraphs: ['IT Asset Lifecycle Management, IT Hardware Asset Management, Software Asset Management, Vendor Management, Location Management, Integrated Ticketing, Network Discovery, Agent-Based Discovery, and Access Control are some of the IATM solutions used by corporations.']
      }
    },
    {
      question: 'What is the importance of having an ITAM solution in an organization?',
      answer: {
        paragraphs: ['All the components mentioned above inside the IATM framework help the organization save costs, optimize software licensing requirements, and avoid contracting oversights from the vendors. Built-in alerts help the asset management engineers to move towards procuring new licenses when the old ones are expiring. The alerts also allow them to track the laptops and desktops with older versions of OS and other applications installed. All these measures ensure legal compliance and avoid security breaches.']
      }
    }
  ];

  constructor (private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.variant = this.route.snapshot.data['variant']; 
  }
}